








import { Vue, Component, Prop } from "@/shared/vuepack";

@Component({})
export default class StatefulLabel extends Vue {

  @Prop({required: true})
  text: string;
}
